var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEmployerAvatar = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125.793,
    height: 153.683,
    viewBox: "0 0 125.793 153.683",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "man-in-suit-and-tie",
    transform: "translate(-2.352 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2010",
    "data-name": "Group 2010",
    transform: "translate(2.352 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2849",
    "data-name": "Path 2849",
    d: "M8.716,48.211a10.239,10.239,0,0,0,2.307,5.035c2.271,15.81,16.462,29.283,27.86,28.719,14.5-.712,24.776-16.337,27.083-28.719a12.633,12.633,0,0,0,2.425-5.562c.617-2.841,1.281-7.122-.427-9.387-.1-.119-.753-.718-.866-.818,1.631-5.883,5.213-16.379-3.706-25.814C58.558,6.552,51.845,3.984,45.779,1.956,27.87-4.027,15.227,4.364,9.392,18.317c-.421.99-3.143,7.258.154,19.16a3.38,3.38,0,0,0-.854.818C6.978,40.555,8.093,45.37,8.716,48.211Z",
    transform: "translate(24.41 0)",
    fill: "#fa616e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2850",
    "data-name": "Path 2850",
    d: "M128.1,70.372c-.5-10.882-1.115-28.126-10.621-42.234,0,0-2.71-3.694-9.138-6.15,0,0-13.959-4.252-20.388-8.848l-2.935,2.01.326,19.083L67.719,81.284a2.632,2.632,0,0,1-4.934,0L45.167,34.234s.326-19.024.32-19.083c.042.16-2.941-2.01-2.941-2.01-6.416,4.6-20.382,8.848-20.382,8.848-6.428,2.455-9.138,6.149-9.138,6.149C3.526,42.246,2.9,59.491,2.4,70.372,2.055,77.892,3.633,80.7,5.613,81.5c24.586,9.868,94.674,9.868,119.266,0C126.872,80.7,128.437,77.892,128.1,70.372Z",
    transform: "translate(-2.352 64.786)",
    fill: "#fa616e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2851",
    "data-name": "Path 2851",
    d: "M20.115,15.976l-.795.018a23.565,23.565,0,0,1-7.685-1.376L18.621,25.31l-6.268,6.049L18.8,70.539a.69.69,0,0,0,.688.581.7.7,0,0,0,.688-.581l6.452-39.18L20.358,25.31l6.885-10.532A29.52,29.52,0,0,1,20.115,15.976Z",
    transform: "translate(43.414 72.067)",
    fill: "#fa616e"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmployerAvatar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/employerAvatar.022b43b2.svg";
export { ForwardRef as ReactComponent };